import styled from 'styled-components';
import Input from './input';

const INPUT_CLASS_NAME = 'inputClassName';
const INPUT_WIDTH = 135;
const FONT_SIZE = 48;
const PLACEHOLDER_COLOR = '#CCCCCC';
const COLOR = '#333333';
const BORDER_BOTTOM = '2px solid #989898';
const ERROR_CLASS_NAME = 'error';

const CodeInput = styled(Input).attrs({
    inputProps: {
        placeholder: '0000',
        inputMode: 'numeric',
    },
    maskProps: {
        mask: '9999',
        alwaysShowMask: true,
        maskChar: '',
    },
    classNames: {
        input: INPUT_CLASS_NAME,
        error: ERROR_CLASS_NAME,
    },
})`
    .${INPUT_CLASS_NAME} {
        font-size: ${FONT_SIZE}px;
        line-height: normal;
        padding-top: 16px;
        color: ${COLOR};
        font-weight: bold;
        font-family: Inter, sans-serif;
        border-bottom: ${BORDER_BOTTOM};
        width: ${INPUT_WIDTH}px;

        &::placeholder {
            color: ${PLACEHOLDER_COLOR};
        }
    }

    .${ERROR_CLASS_NAME} {
        color: ${({ theme }) => theme.colors.negative};
        font-size: 12px;
        font-weight: 500;
        line-height: 17.28px;
        letter-spacing: unset;
    }
`;

export default CodeInput;
